import request from '../request'

/**
 * 设计评审相关接口
 */

/**
 * 新增设计评审
 * @param {Object} data - 设计评审数据
 */
export function addDesignReview(data) {
    return request({
        url: '/project-service/cosys/design/review/add',
        method: 'POST',
        data
    })
}

/**
 * 删除设计评审
 * @param {string|number} id - 设计评审ID
 */
export function deleteDesignReview(id) {
    return request({
        url: `/project-service/cosys/design/review/del/${id}`,
        method: 'GET'
    })
}

/**
 * 获取设计评审详情
 * @param {string|number} id - 设计评审ID
 */
export function fetchDesignReviewDetail(id) {
    return request({
        url: `/project-service/cosys/design/review/detail/${id}`,
        method: 'GET'
    })
}

/**
 * 获取设计评审列表
 * @param {Object} params - 查询参数
 */
export function fetchDesignReviewList(params) {
    return request({
        url: '/project-service/cosys/design/review/list',
        method: 'GET',
        params
    })
}

/**
 * 修改设计评审
 * @param {Object} data - 设计评审数据
 */
export function updateDesignReview(data) {
    return request({
        url: '/project-service/cosys/design/review/update',
        method: 'POST',
        data
    })
}

/**
 * 导出设计评审报告
 * @param {string|number} id - 设计计划ID
 */
export function exportReview(id) {
    return request({
        url: `/project-service/cosys/review/export/${id}`,
        method: 'GET',
        responseType: 'json',
    })
}


/**
 * 重新发起设计评审审批（仅Cancel/Reject状态可操作）
 * @param {Object} data - 设计评审数据
 */
export function resubmitDesignReview(data) {
    return request({
        url: '/project-service/cosys/design/review/resubmit',
        method: 'POST',
        data
    })
}